import type { Camera } from '../types';

/** Keep device identifiers intact while giving monitoring tiles a readable label. */
export function getCameraDisplayName(camera: Pick<Camera, 'camera_id' | 'name'> & Partial<Pick<Camera, 'camera_location' | 'model' | 'serial_number'>>) {
  const original = camera.name?.trim() || camera.camera_location?.trim() || 'Camera';
  const isDeviceIdentifier = (value: string) => value === camera.model || value === camera.serial_number || /^[A-Z]+\d[A-Z0-9_-]*\([A-Z0-9]+\)$/.test(value);
  const location = camera.camera_location?.trim();
  const name = isDeviceIdentifier(original)
    ? (location && !isDeviceIdentifier(location) ? location : 'Camera')
    : original;
  const readable = name === name.toUpperCase() && /^[A-Z\s'-]+$/.test(name)
    ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
    : name;

  return {
    label: readable === 'Camera' ? `Camera ${camera.camera_id}` : `${readable} · ${camera.camera_id}`,
    identifier: `${original}-${camera.camera_id}`,
  };
}
